'use strict';

import angular from 'angular';
import conventionsMiniereRoutes from './conventions-minieres.routes';
import './conventions-minieres.controller';

/**
 * @ngdoc overview
 * @name observatoireApp.conventionsMinieres
 * @description
 * # Module pour les conventions minières
 */
export default angular.module('observatoireApp.conventionsMinieres', [])
  .name;
